import axiosInstance from "services/axios";
import blob2Base64 from "utils/blob2Base64";

export const fetchCertificateData = ({ queryKey }) => {
	const [_, certificateId] = queryKey;
	return axiosInstance
		.get(`/v2/certificates/details/${certificateId}`)
		.then((resp) => resp.data.results.data);
};

export const fetchCertificateImg = ({ queryKey }) => {
	const [_, certificateId] = queryKey;
	return axiosInstance({
		url: `/v2/certificates/verify/${certificateId}`,
		method: "GET",
		responseType: "blob",
	}).then((resp) =>
		blob2Base64(resp.data).then((base64String) => ({
			url: window.URL.createObjectURL(new Blob([resp.data])),
			base64: base64String,
			blob: resp.data,
		}))
	);
};
